import Prestation from "@/model/Prestation"
import hasTotalPrice, {IHasTotalPrice} from "@/model/mixins/Price/hasTotalPrice"
import hasCrossPrice, {IHasCrossPrice} from "@/model/mixins/Price/hasCrossPrice"
import hasTravellers, {IHasTravellers} from "@/model/mixins/Traveller/hasTravellers"
import hasServicesEligible, {IHasServicesEligible} from "@/model/mixins/Service/hasServicesEligible"
import hasServicesSelected, {IHasServicesSelected} from "@/model/mixins/Service/hasServicesSelected"
import {IAccomodationContent} from "@/model/Content/AccomodationContent"
import hasBaseAccomodationQuoteObject, {IHasBaseAccomodationQuoteObject} from "@/model/mixins/hasBaseAccomodationQuoteObject"
import hasQuoteTravellers, { IHasQuoteTravellers } from "@/model/mixins/hasQuoteTravellers"

class AccomodationBase extends Prestation {
    private content: IAccomodationContent | null = null

    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
    }

    public setAccomodationContent(content: IAccomodationContent): void {
        this.content = content
    }
    public getAccomodationContent(): IAccomodationContent | null {
        return this.content
    }

}

export interface IAccomodation extends AccomodationBase, IHasQuoteTravellers, IHasTravellers, IHasServicesEligible, IHasServicesSelected, IHasTotalPrice, IHasCrossPrice, IHasBaseAccomodationQuoteObject {
    setAccomodationContent(content: IAccomodationContent): void
    getAccomodationContent(): IAccomodationContent | null
}


const Accomodation: Constructor<IAccomodation> = hasQuoteTravellers(hasBaseAccomodationQuoteObject(hasCrossPrice(hasTotalPrice(hasServicesEligible(hasServicesSelected(hasTravellers(AccomodationBase)))))))

export default Accomodation